import { Button, ButtonTypeMap, CircularProgress } from '@mui/material';
import { DefaultComponentProps } from '@mui/material/OverridableComponent';

/**
 * 
 * Buttonsubmit allow users to take action of submit to something
 * 
 * ###Import to use it
 *
 *```jsx
 *   import { ButtonSubmit } from '@eco/react-lib'
 *```
 *
 *### Usage
 *
 *```jsx
 *<ButtonSubmit 
 *   label={string} 
 *   isSubmit={boolean} 
 *   disabled={boolean}
 />
 *```
 *
 *### Basic Example
 */

export const ButtonSubmit = ({ className, label, isSubmit, disabled, ...props }: ButtonSubmitType) => {

    return (
        <Button 
            className={`ml-auto ${className}`}
            variant="contained"
            type="submit"
            disabled={isSubmit || disabled}
            {...props}>
            {label}
            {
                isSubmit &&
                <CircularProgress size={18} style={{ marginLeft: "20px", color: "#1976d2" }} />
            }
        </Button>
    )
}

export type ButtonSubmitType = DefaultComponentProps<ButtonTypeMap<{}, "button">> & {
    /** Button label */
    label?: string | React.ReactNode
    /** Flag telling that current button is submitng */
    isSubmit?: boolean
    /** Flag telling if button is disabled */
    disabled?: boolean
}
